var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    y: 0.132812,
    width: 22.0184,
    height: 22.0184,
    rx: 11.0092,
    fill: "black",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1573 6.45561L6.49955 14.5225C6.41541 14.6682 6.37111 14.8334 6.37109 15.0016C6.37108 15.1699 6.41535 15.3351 6.49946 15.4808C6.58357 15.6265 6.70455 15.7475 6.85024 15.8316C6.99593 15.9157 7.1612 15.96 7.32942 15.96H16.6442C16.8124 15.96 16.9777 15.9157 17.1234 15.8316C17.269 15.7475 17.39 15.6265 17.4741 15.4808C17.5582 15.3351 17.6025 15.1699 17.6025 15.0016C17.6025 14.8334 17.5582 14.6682 17.474 14.5225L12.8168 6.45561C12.7327 6.30996 12.6118 6.18901 12.4661 6.10492C12.3204 6.02083 12.1552 5.97656 11.987 5.97656C11.8189 5.97656 11.6536 6.02083 11.508 6.10492C11.3623 6.18901 11.2414 6.30996 11.1573 6.45561Z",
    fill: "#EE404C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0459 8.94531H11.9244C11.6253 8.94531 11.3828 9.18781 11.3828 9.48694V12.0758C11.3828 12.3749 11.6253 12.6174 11.9244 12.6174H12.0459C12.3451 12.6174 12.5876 12.3749 12.5876 12.0758V9.48694C12.5876 9.18781 12.3451 8.94531 12.0459 8.94531Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9852 14.6735C12.3179 14.6735 12.5876 14.4038 12.5876 14.0711C12.5876 13.7384 12.3179 13.4688 11.9852 13.4688C11.6525 13.4688 11.3828 13.7384 11.3828 14.0711C11.3828 14.4038 11.6525 14.6735 11.9852 14.6735Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/Hazard.66d0e156bf26f80d30e4b523ae453315.svg";
export { ForwardRef as ReactComponent };